import { Modal, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export function RefundCouponModal({ open, onClose, setOpen }: ModalProps) {
  const [option, setOption] = useState("refund");

  return (
    <Modal className="modal refundCoupon_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Issue Refund / Coupon</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form">
            <div className="control_group" style={{ marginBottom: "25px" }}>
              <RadioGroup className="flex" value={option} onChange={(e) => setOption(e.target.value)}>
                <FormControlLabel value="refund" control={<Radio />} label="Issue Refund" />
                <FormControlLabel value="coupon" control={<Radio />} label="Generate Coupon" />
              </RadioGroup>
            </div>

            {option === 'refund' && (
              <>
                <div className="control_group">
                  <label>Refund Amount</label>
                  <TextField fullWidth hiddenLabel type="number" />
                </div>
                <div className="control_group">
                  <label>Reason</label>
                  <TextField fullWidth hiddenLabel multiline rows={3} />
                </div>
              </>
            )}

            {option === 'coupon' && (
              <>
                <div className="control_group">
                  <label>Coupon Code</label>
                  <TextField fullWidth hiddenLabel value="AUTO1234" disabled />
                </div>
                <div className="control_group">
                  <label>Discount %</label>
                  <TextField fullWidth hiddenLabel type="number" />
                </div>
                <div className="control_group">
                  <label>Valid Until</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="form_control"
                      slots={{
                        openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="icon" />,
                      }}
                      slotProps={{
                        textField: {
                          placeholder: "Select Date",
                          fullWidth: true,
                          hiddenLabel: true
                        },
                      }}
                      desktopModeMediaQuery="(min-width:0px)"
                    />
                  </LocalizationProvider>
                </div>
              </>
            )}

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}
